/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Upcoming_CancellationsInputs */

const en_admin_dashboard_upcoming_cancellations = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`upcoming cancellations`)
};

const de_admin_dashboard_upcoming_cancellations = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anstehende Abmeldungen`)
};

const es_admin_dashboard_upcoming_cancellations = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`próximas cancelaciones`)
};

const fr_admin_dashboard_upcoming_cancellations = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`annulations à venir`)
};

const nl_admin_dashboard_upcoming_cancellations = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aankomende opzeggingen`)
};

const it_admin_dashboard_upcoming_cancellations = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cancellazioni imminenti`)
};

const pt_br2_admin_dashboard_upcoming_cancellations = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cancelamentos próximos`)
};

const pl_admin_dashboard_upcoming_cancellations = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nadchodzące anulowania`)
};

const hu_admin_dashboard_upcoming_cancellations = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jövőbeli lemondás`)
};

const ro_admin_dashboard_upcoming_cancellations = /** @type {(inputs: Admin_Dashboard_Upcoming_CancellationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anulari viitoare`)
};

/**
* | output |
* | --- |
* | "upcoming cancellations" |
*
* @param {Admin_Dashboard_Upcoming_CancellationsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_upcoming_cancellations = /** @type {((inputs?: Admin_Dashboard_Upcoming_CancellationsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Upcoming_CancellationsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_upcoming_cancellations(inputs)
	if (locale === "de") return de_admin_dashboard_upcoming_cancellations(inputs)
	if (locale === "es") return es_admin_dashboard_upcoming_cancellations(inputs)
	if (locale === "fr") return fr_admin_dashboard_upcoming_cancellations(inputs)
	if (locale === "nl") return nl_admin_dashboard_upcoming_cancellations(inputs)
	if (locale === "it") return it_admin_dashboard_upcoming_cancellations(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_upcoming_cancellations(inputs)
	if (locale === "pl") return pl_admin_dashboard_upcoming_cancellations(inputs)
	if (locale === "hu") return hu_admin_dashboard_upcoming_cancellations(inputs)
	return ro_admin_dashboard_upcoming_cancellations(inputs)
});
export { admin_dashboard_upcoming_cancellations as "admin.dashboard.upcoming_cancellations" }